<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'roleg',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>